document.addEventListener("DOMContentLoaded", () => {
  // ニュースレターのトリガーボタン
  const newsletterTriggerButtons = document.querySelectorAll(
    ".js-newsletter-trigger"
  );

  if (newsletterTriggerButtons.length > 0) {
    newsletterTriggerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        // Promolayerのポップアップを表示
        if (typeof promolayer !== "undefined" && promolayer.triggerDisplay) {
          promolayer.triggerDisplay("fLzagsyDB9GR7oUzjZLy");
        } else {
          console.error(
            "Promolayer not found or triggerDisplay method is not available"
          );
        }
      });
    });
  }
});
